import React from "react";
import { useSelector } from "react-redux";
import ReactVisibilitySensor from "react-visibility-sensor";
import {
  getContent,
  getRightContent,
  getVisibleSensorAnimation,
} from "../assets/js/utils";
import ContentTitle from "./ContentTitle";
import GoalCard from "./GoalCard";
import HorizontalScrollable from "./HorizontalScrollable";

import earningImage from "../assets/images/earning.svg";
import sustainingImage from "../assets/images/sustaining.svg";
import givingImage from "../assets/images/giving.svg";
import initiativeImage from "../assets/images/initiatives.svg";
import strategicAmbitionsImage from "../assets/images/strategic-ambitions.svg";

const goalImages = [earningImage, sustainingImage, givingImage];
const priorityImages = [strategicAmbitionsImage, initiativeImage];

function Content7(props) {
  const generalSettings = useSelector((state) => state.ui.generalSettings);
  const sections = useSelector((state) => state.ui.sections);

  return (
    <>
      <div className="general-m">
        <ContentTitle
          label={getRightContent(
            generalSettings.rtlLanguage,
            getContent().sections[sections.currentSection].content.title
          )}
        />

        <div className="general-separator"></div>
        <ReactVisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <p
              className="paragraph"
              style={getVisibleSensorAnimation(
                isVisible,
                "fade-in-40px 1s backwards"
              )}
            >
              {getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .mainParagraph
              )}
            </p>
          )}
        </ReactVisibilitySensor>

        <div className="general-separator"></div>

        <ReactVisibilitySensor partialVisibility>
          {({ isVisible }) => (
            <h2
              className="note__title"
              style={getVisibleSensorAnimation(
                isVisible,
                "fade-in-40px 1.5s backwards"
              )}
            >
              {getRightContent(
                generalSettings.rtlLanguage,
                getContent().sections[sections.currentSection].content
                  .firstTitle
              )}
            </h2>
          )}
        </ReactVisibilitySensor>
      </div>
      <div className="goals-container">
        <HorizontalScrollable
          headerItems={getRightContent(generalSettings.rtlLanguage, [
            [
              { label: "2025 Goals" },
              { label: "Where to Play" },
              { label: "How to Win" },
            ],
            [
              { label: "أهداف 2025" },
              { label: "مجال العمل" },
              { label: "وسائل التنفيذ" },
            ],
          ])}
          contentComponentsForHeader={[
            getContent().sections[
              sections.currentSection
            ].content.goalCards[0].map((goalCard, index) => (
              <GoalCard
                key={index}
                title={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.title
                )}
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.text
                )}
                icon={goalImages[index]}
              />
            )),
            getContent().sections[
              sections.currentSection
            ].content.goalCards[1].map((goalCard, index) => (
              <GoalCard
                key={index}
                title={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.title
                )}
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.text
                )}
                icon={goalImages[index]}
              />
            )),
            getContent().sections[
              sections.currentSection
            ].content.goalCards[2].map((goalCard, index) => (
              <GoalCard
                key={index}
                title={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.title
                )}
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.text
                )}
                icon={goalImages[index]}
              />
            )),
          ]}
        />
      </div>

      <div className="general-separator"></div>

      <ReactVisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <h2
            className="note__title"
            style={getVisibleSensorAnimation(
              isVisible,
              "fade-in-40px 1.5s backwards"
            )}
          >
            {getRightContent(
              generalSettings.rtlLanguage,
              getContent().sections[sections.currentSection].content.secondTitle
            )}
          </h2>
        )}
      </ReactVisibilitySensor>
      <div className="priorities-container">
        <HorizontalScrollable
          headerItems={getRightContent(generalSettings.rtlLanguage, [
            [
              { label: "01" },
              { label: "02" },
              { label: "03" },
              { label: "04" },
            ],
            [{ label: "1" }, { label: "2" }, { label: "3" }, { label: "4" }],
          ])}
          contentComponentsForHeader={[
            getContent().sections[
              sections.currentSection
            ].content.prioritieCards[0].map((goalCard, index) => (
              <GoalCard
                key={index}
                title={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.title
                )}
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.text
                )}
                icon={priorityImages[index]}
                boldParagraphIndexes={goalCard.boldParagraphIndexes}
              />
            )),
            getContent().sections[
              sections.currentSection
            ].content.prioritieCards[1].map((goalCard, index) => (
              <GoalCard
                key={index}
                title={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.title
                )}
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.text
                )}
                icon={priorityImages[index]}
                boldParagraphIndexes={goalCard.boldParagraphIndexes}
              />
            )),
            getContent().sections[
              sections.currentSection
            ].content.prioritieCards[2].map((goalCard, index) => (
              <GoalCard
                key={index}
                title={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.title
                )}
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.text
                )}
                icon={priorityImages[index]}
                boldParagraphIndexes={goalCard.boldParagraphIndexes}
              />
            )),
            getContent().sections[
              sections.currentSection
            ].content.prioritieCards[3].map((goalCard, index) => (
              <GoalCard
                key={index}
                title={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.title
                )}
                text={getRightContent(
                  generalSettings.rtlLanguage,
                  goalCard.text
                )}
                icon={priorityImages[index]}
                boldParagraphIndexes={goalCard.boldParagraphIndexes}
              />
            )),
          ]}
        />
      </div>
      <div className="general-separator"></div>
    </>
  );
}

export default Content7;
